import { supabase } from '../lib/supabase';
import { CreatorLandingPage, CreatorLandingReview, CreatorLandingFaq, CreatorLandingFeature, Recipe, CreatorDetails } from '../types/database';

export const landingPageService = {
  async getLandingPageBySubdomain(subdomain: string): Promise<CreatorLandingPage | null> {
    const { data, error } = await supabase
      .from('creator_landing_pages')
      .select('*')
      .eq('subdomain', subdomain)
      .eq('is_active', true)
      .single();

    if (error) {
      console.error('Error fetching landing page:', error);
      return null;
    }

    return data;
  },

  async getLandingPageById(id: string): Promise<CreatorLandingPage | null> {
    const { data, error } = await supabase
      .from('creator_landing_pages')
      .select('*')
      .eq('id', id)
      .eq('is_active', true)
      .single();

    if (error) {
      console.error('Error fetching landing page:', error);
      return null;
    }

    return data;
  },

  async getLandingPageByCreatorId(creatorId: string): Promise<CreatorLandingPage | null> {
    const { data, error } = await supabase
      .from('creator_landing_pages')
      .select('*')
      .eq('creator_id', creatorId)
      .eq('is_active', true)
      .single();

    if (error) {
      console.error('Error fetching landing page:', error);
      return null;
    }

    return data;
  },

  async getLandingPageReviews(pageId: string): Promise<CreatorLandingReview[]> {
    console.log('Fetching reviews for page ID:', pageId);
    const { data, error } = await supabase
      .from('creator_landing_reviews')
      .select('*')
      .eq('page_id', pageId);

    if (error) {
      console.error('Error fetching reviews:', error);
      console.error('Error details:', {
        message: error.message,
        details: error.details,
        hint: error.hint,
        code: error.code
      });
      return [];
    }

    console.log('Reviews fetched successfully:', data);
    return data || [];
  },

  async getLandingPageFaqs(landingId: string): Promise<CreatorLandingFaq[]> {
    console.log('Fetching FAQs for landing ID:', landingId);
    const { data, error } = await supabase
      .from('creator_landing_faqs')
      .select('*')
      .eq('landing_id', landingId);

    if (error) {
      console.error('Error fetching FAQs:', error);
      console.error('Error details:', {
        message: error.message,
        details: error.details,
        hint: error.hint,
        code: error.code
      });
      return [];
    }

    console.log('FAQs fetched successfully:', data);
    return data || [];
  },

  async getLandingPageFeatures(landingId: string): Promise<CreatorLandingFeature[]> {
    const { data, error } = await supabase
      .from('creator_landing_features')
      .select('*')
      .eq('landing_id', landingId)
      .order('order', { ascending: true });

    if (error) {
      console.error('Error fetching features:', error);
      return [];
    }

    return data || [];
  },

  async getCreatorRecipes(creatorId: string): Promise<Recipe[]> {
    const { data, error } = await supabase
      .from('Recipes')
      .select('*')
      .eq('UserID', creatorId)
      .order('DateCreated', { ascending: false })
      .limit(10);

    if (error) {
      console.error('Error fetching recipes:', error);
      return [];
    }

    return data || [];
  },

  async getCreatorDetailsByAuthId(authId: string): Promise<CreatorDetails | null> {
    const { data, error } = await supabase
      .from('CreatorDetails')
      .select('*')
      .eq('id', authId)
      .single();

    if (error) {
      console.error('Error fetching creator details:', error);
      return null;
    }

    return data;
  }
}; 